import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { DragSource,DropTarget } from 'react-dnd';
import ItemTypes from '../../ItemTypes.js';
import Toolbar from './Toolbar.js';
import DroppableElement from './DroppableElement.js';
import ElementWrapper from './ElementWrapper.js';
import DropContentElement from './DropContentElement.js';

import uuidV4 from 'uuid/v4';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

import {deleteRow,deleteElement,setUiState,moveElement,convertToElement,addPlaceholder,setSidebarState} from '../../actions/Builder.js';

import FileUpload from './FileUpload.js';
import Text from './Text.js';
import Spacing from './Spacing.js';

import {getItemObject} from '../../helpers/functions.js';

function calculateSorting(newPosition,direction,newSorting) {
	const highest = Object.keys(newSorting).length;

	if(highest == 0) {
		return {'new':1,'list':newSorting};
	}

	// Element is moved inside same column. Just change newSorting
	if(typeof newSorting[newPosition.id] !== 'undefined') {
		let old = {'id':false,'sorting':false};

		for(let id in newSorting) {
			if(newSorting[id] == newPosition.sorting) {
				old.id = id;
			}
			if(id == newPosition.id) {
				old.sorting = newSorting[id];
			}
		}

		newSorting[newPosition.id] = newPosition.sorting;
		newSorting[old.id] = old.sorting;

		return {'new':newPosition.sorting,'list':newSorting};

	}

	if(highest == newPosition.sorting) {
		if(direction == 'UP') {
			return {'new':highest-1,'list':newSorting};
		}else{
			return {'new':highest+1,'list':newSorting};
		}
	}



	for(let i in newSorting) {
		if(newSorting[i] >= newPosition.sorting) {
			newSorting[i] = newSorting[i]+1;
		}
	}
// TODO når man flytter plass på to eksisterende virker det ikke på det øverste. dvs flytte 2 -> 1. Tror det kommer av at newsorting begynner på 2, mens newindex = 1
	

	return {'new':newPosition.sorting,'list':newSorting};

}


const cardSource = {
	beginDrag(props) {
		return {
			type: props.type,
			sorting: props.row.sorting,
			id: props.row.id,
			settings:props.settings
		};
	}
};

function collect(connect, monitor) {
	return {
		connectDragSource: connect.dragSource(),
		connectDragPreview: connect.dragPreview(),
		isDragging: monitor.isDragging()
	};
}
function collectDrop(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDropTarget: connect.dropTarget(),
        // You can ask the monitor about the current drag state:
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
        itemType: monitor.getItemType()
    };
}

const propTypes = {

	// Injected by React DnD:
	isDragging: PropTypes.bool.isRequired,
	connectDragSource: PropTypes.func.isRequired,
	connectDragPreview: PropTypes.func.isRequired,
	moveRow: PropTypes.func.isRequired
};


const chessSquareTarget = {
    canDrop(props, monitor) {
        const item = monitor.getItemType();
        return true;
    },

    hover(props, monitor, component) {
    	const dragIndex = monitor.getItem().sorting;
	    const hoverIndex = props.row.sorting;

	    // Don't replace items with themselves
	    if (dragIndex === hoverIndex) {
	      return;
	    }

	    // Determine rectangle on screen
	    const hoverBoundingRect = ReactDOM.findDOMNode(component).getBoundingClientRect();

	    // Get vertical middle
	    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

	    // Determine mouse position
	    const clientOffset = monitor.getClientOffset();

	    // Get pixels to the top
	    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

	    // Only perform the move when the mouse has crossed half of the items height
	    // When dragging downwards, only move when the cursor is below 50%
	    // When dragging upwards, only move when the cursor is above 50%

	    // Dragging downwards
	    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
	      return;
	    }

	    // Dragging upwards
	    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
	      return;
	    }

	    let oldPosition = {
	    	id:monitor.getItem().id,
	    	sorting:monitor.getItem().index,
	    	index:monitor.getItem().index
	    };

	    let newPosition = {
	    	sorting:(hoverIndex == 0 ? 1:hoverIndex),
	    	index:(hoverIndex == 0 ? 1:hoverIndex),
	    	id:monitor.getItem().id
	    };


	    let newSorting = [];
	    let c = 1;

	    for(let i in props.rows) {
	    	let el = props.rows[i];
	    	if(el.col == newPosition.col) {
	    		newSorting[el.id] = props.rows[i].sorting;
	    		c++;
	    	}
	    	
	    }
	    let direction = 'DOWN';
	   	if(hoverClientY < hoverMiddleY) {
	    	direction = 'UP';
	    }

	    let calculatedSorting = calculateSorting(newPosition,direction,newSorting);
	    newPosition.sorting = calculatedSorting.new;

	    if(newPosition.id == false) {
	    	newPosition.columns = monitor.getItem().settings.columns
	    	let placeholder = props.addRowPlaceholder(newPosition,calculatedSorting);
	    	monitor.getItem().id = placeholder.id;
	    }else{
	    	props.moveRow(newPosition, calculatedSorting);
	    }

	    monitor.getItem().sorting = newPosition.sorting;
    },

    drop(props, monitor, component) {console.log('drop');
       if (monitor.didDrop()) {
            return;
        }
        const item = monitor.getItem();

        if(item.new === true) {
        	props.addRow(item);
        }
    }
};


class Row extends React.Component {
	constructor(props) {
		
		super(props);
		this.renderColumns = this.renderColumns.bind(this);
		this.renderElements = this.renderElements.bind(this);
		this.moveElement = this.moveElement.bind(this);
		this.addElement = this.addElement.bind(this);
		this.addPlaceholder = this.addPlaceholder.bind(this);
		this.handleMouseEnter = this.handleMouseEnter.bind(this);
		this.handleMouseLeave = this.handleMouseLeave.bind(this);
		this.deleteElement = this.deleteElement.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
	}

	addPlaceholder(newPosition,newSorting) {
		newPosition.id = uuidV4();
		newPosition.type = 'placeholder';

		this.props.addPlaceholder(newPosition,newSorting);
		return newPosition;
	}

	addElement(element) {
		let el = getItemObject(element.type,false);

		el.item.id = element.id;

		this.props.convertToElement(element,el);
	}

	renderElements(col_num) {
		let elements = [];

		if(this.props.elements.length > 0) {
			this.props.elements.map((el) => {
				if(el.col == col_num) {
					elements.push(<ElementWrapper deleteElement={this.deleteElement} row_cols={this.props.row.columns} isHoveringElement={this.props.builder.ui.isHoveringElement} setUiState={this.props.setUiState} setSidebarState={this.props.setSidebarState} elements={this.props.elements} addPlaceholder={this.addPlaceholder} addElement={this.addElement} moveElement={this.moveElement}  key={`row-${this.props.row.id}-column-${col_num}-element-${el.id}`} element={el} />);
				}
			});
		}

		if(elements.length == 0) {
			//elements.push(<DropContentElement col={col_num} rowId={this.props.row.id} moveElement={this.moveElement} key={`row-${this.props.rowId}-empty-column-${col_num}`}>Drop content here</DropContentElement>);

			elements.push(<ElementWrapper deleteElement={this.deleteElement} addPlaceholder={this.addPlaceholder} addElement={this.addElement} moveElement={this.moveElement}  key={`row-${this.props.row.id}-column-${col_num}-empty-column`} element={{type:'empty-column',rowId:this.props.row.id,'col':col_num}} />);
		}

		return elements;
	}

	renderColumns() {
		let cols = [];


		for(let i=1;i<=this.props.row.columns;i++) {
			let styles = {};

			styles.width = 100/this.props.row.columns+'%';
			styles.padding = this.props.row.innerPadding;

			cols.push(
				<DroppableElement acceptDropType={ItemTypes.ELEMENT} styles={styles} key={`row-${this.props.rowId}-col-${i}`} classes="valign-top" type="td">
					{this.renderElements(i)}
				</DroppableElement>
			);
		}

		//cols.push(this.renderPlaceholder());

		return cols;
	}

	moveElement(newPosition,newSorting) {
		this.props.moveElement(newPosition,newSorting);
	}

	handleMouseEnter() {
		this.props.setUiState({'isHoveringRow':this.props.row.id});
	}

	handleMouseLeave() {
		this.props.setUiState({'isHoveringRow':false});
	}

	deleteRow() {
		for(let e in this.props.row.elements) {
			this.deleteElement(this.props.row.elements[e]);
		}

		if(Object.keys(this.props.builder.rows).length == 1) {
			alert('Ikke lov å slette siste row. Lag ny og slett');
			return;
		}

		this.props.deleteRow(this.props.row.id);
	}

	deleteElement(id) {
		this.props.deleteElement(id);
	}

	render() {
		const { isDragging, connectDragPreview,connectDragSource,connectDropTarget } = this.props;
		const opacity = isDragging ? 0 : 1;

		let rowClasses = 'table-wrapper';
		if(this.props.builder.ui.isHoveringRow == this.props.row.id && this.props.builder.ui.isHoveringElement === false) {
			rowClasses += ' selected';
		}

		if(this.props.row.type == 'placeholder') {
			return connectDropTarget(<div className="row-placeholder">Place row here</div>);
		}

		let outer_table_style = {};
		let inner_table_style = {};

		outer_table_style.backgroundColor = this.props.row.outerBackgroundColor;
		outer_table_style.borderTop = this.props.row.outerBorderTop.replace(/\|/g,' ');
		outer_table_style.borderBottom = this.props.row.outerBorderBottom.replace(/\|/g,' ');

		inner_table_style.backgroundColor = this.props.row.innerBackgroundColor;
		inner_table_style.borderTop = this.props.row.innerBorderTop.replace(/\|/g,' ');
		inner_table_style.borderBottom = this.props.row.innerBorderBottom.replace(/\|/g,' ');

		return connectDropTarget(connectDragPreview(
			<div onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave} className={rowClasses} style={{opacity}}>
				<table className="outer-table" style={outer_table_style}>
					<tbody>
						<tr>
							<td>
								<div className="e toolbar">
									<div className="btn-group btn-group-sm" role="group">
									{connectDragSource(
										<button type="button" className="btn btn-icon btn-default btn-outline"><i className="icon wb-move" aria-hidden="true"></i></button>
									)}
									<button type="button" onClick={(e) => {this.props.setSidebarState({'visible':'row','selectedRow':this.props.row.id}); e.stopPropagation();}} className="btn btn-icon btn-default btn-outline"><i className="icon wb-settings" aria-hidden="true"></i></button>
									<button type="button" onClick={(e) => {this.deleteRow(); e.stopPropagation();}} className="btn btn-icon btn-default btn-outline"><i className="icon wb-trash" aria-hidden="true"></i></button>
									</div>
								</div>
								<table className="e-row" style={inner_table_style}>
									<tbody>
										<tr>
											{this.renderColumns()}
										</tr>
									</tbody>
								</table>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		));
	}
}


const mapStateToProps = (state) => {
	return {
		builder:state.builder
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({deleteRow,deleteElement,setUiState,setSidebarState,convertToElement,addPlaceholder,moveElement},dispatch)
}

Row.propTypes = propTypes;
Row = connect(mapStateToProps,mapDispatchToProps)(Row);
Row = DropTarget([ItemTypes.ROW,ItemTypes.NEW_ROW], chessSquareTarget, collectDrop)(Row);
// Export the wrapped component:
export default DragSource(ItemTypes.ROW, cardSource, collect)(Row);




// WEBPACK FOOTER //
// ./components/builder/Row.js